import React, { useState, useEffect } from "react";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Box,
  MenuItem,
  Chip,
  Checkbox,
  ListItemText,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

import {
  visualizationValidation,
  descriptionValidation,
  endpoint,
  uuidValidation,
} from "../../config";
import categoriesApi from "../../hooks/GET/categories";
import { customToast } from "../../lib/toastLib";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function VisualizationDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 250,
      },
    },
  };

  // props value
  const {
    open,
    handleClose,
    dataId,
    dataName,
    dataDescription,
    // dataEmbedCode,
    dataCategories,
    // dataGroupId,
    dataReportId,
    // dataIsProtected,
  } = props;

  // categories list logic start
  const [categoriesList, setCategoriesList] = useState([]);

  useEffect(() => {
    categoriesApi()
      .then((data) => {
        setCategoriesList(data);
      })
      .catch((error) => console.log(error));
  }, []);
  // categories list logic end

  // state logic start
  const initialState = {
    name: "",
    nameError: "",
    description: "",
    descriptionError: "",
    // embedCode: "",
    categories: [],
    // groupId: "",
    // groupIdError: "",
    reportId: "",
    reportIdError: "",
    // isProtected: false,
  };

  const [state, setState] = useState({ ...initialState });

  const handleNameChange = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      name: value,
      nameError:
        value && !value.match(visualizationValidation.regex)
          ? visualizationValidation.message
          : "",
    });
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      description: value,
      descriptionError:
        value && !value.match(descriptionValidation.regex)
          ? descriptionValidation.message
          : "",
    });
  };

  // const handleEmbedCodeChange = (e) => {
  //   const value = e.target.value;
  //   setState({ ...state, embedCode: value });
  // };

  const handleCategoriesChange = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      categories: typeof value === "string" ? value.split(",") : value,
    });
  };

  // const handleGroupIdChange = (e) => {
  //   const value = e.target.value;
  //   setState({
  //     ...state,
  //     groupId: value,
  //     groupIdError:
  //       value && !value.match(uuidValidation.regex)
  //         ? uuidValidation.message
  //         : "",
  //   });
  // };

  const handleReportIdChange = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      reportId: value,
      reportIdError:
        value && !value.match(uuidValidation.regex)
          ? uuidValidation.message
          : "",
    });
  };

  // const handleIsProtectedChange = (e) => {
  //   setState({ ...state, isProtected: e.target.checked });
  // };
  // state logic end

  // submit button disable state logic start
  const [isSubmitBtnDisbaled, setIsSubmitBtnDisbaled] = useState(true);

  useEffect(() => {
    setIsSubmitBtnDisbaled(
      (!state.name || state.nameError ? true : false) ||
      (!state.description || state.descriptionError ? true : false) ||
      // (!state.isProtected && !state.embedCode) ||
      // (state.isProtected && !state.groupId) ||
      // (state.isProtected && !state.reportId) ||
      (!state.reportId || state.reportIdError ? true : false) ||
      state.categories.length === 0
    );
  }, [state]);
  // submit button disable state logic end

  // handle submit logic start
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const handleCatchLogic = (error) => {
      setSubmitBtnLoading(false);
      if (error.response) {
        customToast.error(error.response.data?.message);
      } else {
        customToast.error(error.message);
      }
    };

    const requestBody = {
      title: state.name,
      description: state.description,
      // url: state.isProtected ? "" : state.embedCode,
      url: "",
      categories: state.categories.map((e) => JSON.parse(e).id),
      // ...(state.isProtected && {
      // groupId: state.groupId,
      reportId: state.reportId,
      // }),
      isProtected: true,
    };
    setSubmitBtnLoading(true);
    if (!dataId) {
      axios
        .post(`${endpoint}/api/visualization`, requestBody)
        .then(() => {
          setSubmitBtnLoading(false);
          customToast.success("Visualization added successfully");
          handleClose(true);
        })
        .catch((error) => handleCatchLogic(error));
    } else {
      axios
        .put(`${endpoint}/api/visualization/${dataId}`, requestBody)
        .then(() => {
          setSubmitBtnLoading(false);
          customToast.success("Visualization updated successfully");
          handleClose(true);
        })
        .catch((error) => handleCatchLogic(error));
    }
  };
  // handle submit logic end

  // reset & value assign logic start
  useEffect(() => {
    if (open) {
      setState({
        ...initialState,
        ...(dataName && { name: dataName }),
        ...(dataDescription && { description: dataDescription }),
        // ...(dataEmbedCode && { embedCode: dataEmbedCode }),
        ...(dataCategories && {
          categories: dataCategories.map((e) => JSON.stringify(e)),
        }),
        // ...(dataGroupId && { groupId: dataGroupId }),
        ...(dataReportId && { reportId: dataReportId }),
        // ...(dataIsProtected && { isProtected: dataIsProtected }),
      });
    }
  }, [open]);
  // reset & value assign logic end

  return (
    <Dialog
      open={open}
      scroll="paper"
      fullScreen={fullScreen}
      fullWidth
      TransitionComponent={Transition}
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        <DialogContent>
          <Grid container justifyContent="flex-end" sx={{ mb: 2 }}>
            <IconButton onClick={() => handleClose(false)}>
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid container justifyContent="center" spacing={3}>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Name"
                name="name"
                value={state.name}
                onChange={handleNameChange}
                error={state.nameError ? true : false}
                helperText={state.nameError}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Description"
                name="description"
                value={state.description}
                onChange={handleDescriptionChange}
                error={state.descriptionError ? true : false}
                helperText={state.descriptionError}
              />
            </Grid>
            {/* <Grid item xs={12} textAlign="center">
              <FormControlLabel
                control={
                  <Switch
                    checked={state.isProtected}
                    onChange={handleIsProtectedChange}
                  />
                }
                label="IsProtected"
              />
            </Grid> */}
            {/* {!state.isProtected ? (
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Embed Code"
                  name="embedCode"
                  value={state.embedCode}
                  onChange={handleEmbedCodeChange}
                />
              </Grid>
            ) : (
              <> */}
            {/* <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    label="Group Id"
                    name="groupId"
                    value={state.groupId}
                    onChange={handleGroupIdChange}
                    error={state.groupIdError ? true : false}
                    helperText={state.groupIdError}
                  />
                </Grid> */}

            {/* </>
            )} */}
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Report Id"
                name="reportId"
                value={state.reportId}
                onChange={handleReportIdChange}
                error={state.reportIdError ? true : false}
                helperText={state.reportIdError}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Categories</InputLabel>
                <Select
                  multiple
                  value={state.categories}
                  onChange={handleCategoriesChange}
                  input={<OutlinedInput label="Categories" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value, idx) => (
                        <Chip key={idx} label={JSON.parse(value).name} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {categoriesList.map((option, idx) => (
                    <MenuItem key={idx} value={JSON.stringify(option)}>
                      <Checkbox
                        checked={
                          state.categories.indexOf(JSON.stringify(option)) > -1
                        }
                      />
                      <ListItemText primary={option.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            color="secondary"
            variant="contained"
            size="large"
            fullWidth
            type="submit"
            disabled={isSubmitBtnDisbaled}
            loading={submitBtnLoading}
          >
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

